import { useSearchParamsState } from 'hooks/useSearchParamState';
import { useStore } from 'hooks/useStore';
import { AutoComplete } from 'primereact/autocomplete';
import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

export const useUnonstrainedForecastSearchBar = () => {
  const {
    UnconstrainedForecastViewStore: {
      conceptDetails,
      conceptSearchInput,
      isAllConceptLoading,
      isConceptDetailsLoading,
      filteredConceptsForSearch,
      handleFetchAllConceptDetailsForSearch,
      handleFetchAllDetailsByGFC,
      handleFilterConceptSearch,
      handleConceptSearchInputChange,
      handleGetConceptDetails,
      setSearchInput,
      allDrugMoleculesDetailsForSearch,
      setIsConceptDetailsLoading,
      setDirectCurrentTabIndex,
      lastNdcValueEntered,
      setIndirectCurrentTabIndex,
    },
  } = useStore();
  const [gfcParam, _setGfcParam] = useSearchParamsState('gfc', '');
  const [_ndcParama, setNdcParam] = useSearchParamsState('ndc', '');
  const navigate = useNavigate();

  const handleSearch = async (value: string) => {
    if (!value) return;

    const currURL = window.location.href;
    const url_check = currURL.includes('edit');
    // check if the concept search input is NDC wise

    let tempConceptSearchInput = value;

    if (tempConceptSearchInput.includes('NDC')) {
      const tempDrugDetails = allDrugMoleculesDetailsForSearch.filter(
        item => item.NDC11 == lastNdcValueEntered
      );
      if (tempDrugDetails.length > 0) {
        setNdcParam(tempDrugDetails[0].NDC11);
        setSearchInput(tempDrugDetails[0].Concept);
        tempConceptSearchInput = tempDrugDetails[0].Concept;
        if (url_check) {
          navigate(
            `/fdp/unconstrained_forecast?gfc=${tempDrugDetails[0].GFC}&ndc=${tempDrugDetails[0].NDC11}`
          );
          return;
        }
      }
    }

    const matchedMolecules = allDrugMoleculesDetailsForSearch.filter(
      concept => concept.Concept == tempConceptSearchInput
    );
    if (matchedMolecules.length === 0) {
      return;
    }

    if (url_check) {
      navigate(`/fdp/unconstrained_forecast?gfc=${matchedMolecules[0].GFC}?ndc=00`);
    }

    if (matchedMolecules.length > 0 && !url_check) {
      const selectedConcept = matchedMolecules[0];
      await handleGetConceptDetails(selectedConcept.GFC);
      setIndirectCurrentTabIndex(0);
      setDirectCurrentTabIndex(0);
    } else {
      setIsConceptDetailsLoading(false);
    }
  };

  const handleEnterKeyDownConceptSearchField = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      handleSearch(conceptSearchInput);
    }
  };
  const isSearchButtonDisabled = () => {
    return conceptDetails ? false : true;
  };
  const serchfieldRef = useRef<AutoComplete>(null);

  useEffect(() => {
    serchfieldRef.current?.focus();
    if (gfcParam) {
      handleFetchAllDetailsByGFC(gfcParam);
    } else {
      handleFetchAllConceptDetailsForSearch();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    serchfieldRef,
    conceptSearchInput,
    isSearchButtonDisabled,
    conceptDetails,
    isAllConceptLoading,
    isConceptDetailsLoading,
    filteredConceptsForSearch,
    handleFetchAllConceptDetailsForSearch,
    handleFilterConceptSearch,
    handleConceptSearchInputChange,
    handleGetConceptDetails,
    handleSearch,
    handleEnterKeyDownConceptSearchField,
  };
};
